import { IArticleListFilters } from "./ArticleList.model"

export const ITEMS_PER_PAGE_OPTIONS = [5, 10, 15, 20]
export const YEAR_SELECT_COUNT = 3
export const DEBOUNCE_TIME = 500

export const DEFAULT_FILTERS: IArticleListFilters = {
  page: 1,
  itemsPerPage: 10,
  query: "",
}
